/**
 * Honeypot — invisible bait input that human users never see (off-screen,
 * tab-skipped, aria-hidden, autocomplete off) but headless bots filling
 * every available form field will populate. <LeadForm> sends it as `hp`;
 * /api/v2/leads drops any submission where it is non-empty.
 */

const HONEYPOT_STYLE = {
  position: "absolute",
  left: "-9999px",
  width: "1px",
  height: "1px",
  overflow: "hidden",
};

export default function Honeypot({ value, onChange }) {
  return (
    <input
      type="text"
      name="website"
      tabIndex="-1"
      autoComplete="off"
      aria-hidden="true"
      value={value}
      onChange={onChange}
      style={HONEYPOT_STYLE}
      data-testid="honeypot-website"
    />
  );
}
